import { useGetCart } from '../components/CartQuery/CartQuery'
import { useAnalytics } from '../components/AnalyticsProvider/AnalyticsProvider'
import { getDaasAwareDiningOption } from './cart-helpers'
import { useCallback } from 'react'

export const getFlagsLoading = (featureFlags) => Object
  .values(featureFlags)
  .some(value => value === null)

export const useTrackPurchase = () => {
  const { cart } = useGetCart()
  const { track } = useAnalytics()

  return useCallback((completedOrder) => {
    const daasAwareDiningOptionBehavior = getDaasAwareDiningOption(cart)
    const { guid, selections, total, tax, tip } = completedOrder
    track('Completed Order', {
      'id': guid,
      'itemCount': selections.length,
      'diningOptionBehavior': daasAwareDiningOptionBehavior,
      'revenue': total,
      'orderTax': tax,
      'tip': tip || 0
    })
  }, [cart, track])
}
